import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation, inject } from '@angular/core';

import { DiscountThemeService } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

@Component({
  standalone: true,
  selector: 'cake-item-price',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, NgCakeItEasyUtilsModule],
  templateUrl: './cake-item-price.component.html',
  styleUrls: ['./cake-item-price.component.scss']
})
export class CakeItemPriceComponent {

  @Input() currency: string;
  @Input() pieces: boolean;
  @Input() price: number;
  @Input() perUnitText: string;
  @Input() isDifferentPrices: boolean;
  @Input() hasPicture = true;
  @Input() discount: number;

  protected discountTheme = inject(DiscountThemeService);
}
